module.exports = __webpack_public_path__ + "static/media/5-6.1427c718.mp3";